
import axios from "axios";
export default {
  watchQuery:true,
  async asyncData({ app, req, route, store, redirect }) {
    let host = "";
    if (process.server) {
      host = req.headers.host + route.fullPath;
    } else {
      host = location.host + route.fullPath;
    }
    let p = route.params.projection;
    let prj;
    try {
      prj = (
        await axios.get(
          `${process.env.axiosUrl}/stores/projection/${
            store.getters.store._id
          }?page=${encodeURIComponent(p)}`
        )
      ).data;
    } catch (error) {
      console.error(error);
    }
    if (!prj) {
      redirect("/");
    }
    let projection = prj;
    let t = prj.title;
    let f = prj.flag;
    let preview = "";
    if (app.$cookies.get("preview")) {
      let pr = (app.$cookies.get("preview") || "").split(":::");
      if (pr[1] == store.getters.store.id) {
        preview = `&preview=${pr[0]}`;
      }
    }
    try {
      let res = await axios.get(
        `${process.env.axiosUrl}/stores/${
          store.getters.store.id
        }?elements=${encodeURIComponent(f)},${encodeURIComponent(t)}&build=${
          (store.getters.store.build || {}).build_no
        }&styleless=true&elementsonly=true${preview}`,
        {
          headers: {
            shopster: host,
          },
        }
      );
     
      store.getters.store.activePages = [
        ...store.getters.store.activePages,
        `${encodeURIComponent(f)},${encodeURIComponent(t)}`,
      ];
      store.commit("store", store.getters.store);
      let elements = res.data.eshop.elements.filter(
        (e) => e.page == f || e.page == t
      );
      elements =
        (await app.$hyperElement.populateData({ page: f, elements, app })) ||
        [];
      let es = [
        ...store.getters.store.eshop.elements.filter(
          (e) => e.static || e.page != f
        ),
        ...elements,
      ];
      store.commit("elements", es);
      return { projection };
    } catch (e) {
      console.error(e);
      return { projection };
    }
  },
  head() {
    const p = this.projection || {};
    // Per-page presets from the dashboard (Open Graph / Meta). They were stored
    // but never emitted, so every preset looked dead (#23417).
    const presets = (p.og || []).filter((o) => o && o.property && o.content);
    const asProperty = (k) =>
      /^(og:|article:|product:|book:|business:|profile:|fb:)/.test(k);
    const overridden = presets.map((o) => o.property);
    return {
    __dangerouslyDisableSanitizers: ['script'],
      
      script:[{
        type: "application/ld+json",
        innerHTML:`${this.projection?.ldjson}`
      }],
      title: p.title,
      meta: [
        ...this.$hyperSeo
          .meta({
            description: p.seo_description ? p.seo_description : p.title,
            "og:description": p.seo_description ? p.seo_description : p.title,
            keywords: p.seo_keywords ? p.seo_keywords : "",
          })
          .filter((m) => !overridden.includes(m.hid)),
        ...presets.map((o) =>
          asProperty(o.property)
            ? { hid: o.property, property: o.property, content: o.content }
            : { hid: o.property, name: o.property, content: o.content }
        ),
      ],
    };
  },
  name: "featured",
  data() {
    return {
      projection: {},
      SwiperBreakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
        1400: {
          slidesPerView: 4,
        },
        1560: {
          slidesPerView: 5,
        },
      },
    };
  },
  created() {},
  mounted() {},
  methods: {},
};
